import { produce } from 'immer';
import { extractError } from 'app/lib/error';
import { ANALYZE_SCHEMA_USAGE, CLOSE_DIALOG, OPEN_DIALOG } from './types.js';

export const INITIAL_STATE = {
    isDialogOpen: false,
    schemaFqn: null,
    isProcessing: false,
    error: null
};

export const schemaUsageReducer = produce((draft, action) => {
    switch (action.type) {
        case OPEN_DIALOG:
            draft.isDialogOpen = true;
            draft.schema = action.payload;
            break;

        case CLOSE_DIALOG:
            draft.isDialogOpen = false;
            draft.schema = null;
            break;

        case ANALYZE_SCHEMA_USAGE.STARTED:
            draft.isProcessing = true;
            draft.error = null;
            break;

        case ANALYZE_SCHEMA_USAGE.PROGRESS: {
            draft.isProcessing = false;
            draft.isDialogOpen = false;
            break;
        }

        case ANALYZE_SCHEMA_USAGE.FAILED: {
            if (draft.isDialogOpen) {
                draft.error = extractError(action.payload);
                draft.isProcessing = false;
            }
            break;
        }

        default:
            break;
    }
}, INITIAL_STATE);
